export default {
    contractEditHeader: {
        backToBinEditor: 'Natrag na uređivač košara',
        loadError: 'Nije moguće učitati ugovor',
    },
}
